function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import React, { PureComponent, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { safeSelect } from '@sie/web-common-utils';
import { classNamesFor } from '../utils/classNames';

var Label = /*#__PURE__*/function (_PureComponent) {
  _inherits(Label, _PureComponent);

  var _super = _createSuper(Label);

  function Label() {
    var _this;

    _classCallCheck(this, Label);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocused: false
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      return _this.setState({
        isFocused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      return _this.setState({
        isFocused: false
      });
    });

    return _this;
  }

  _createClass(Label, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          children = _this$props.children;
      var isFocused = this.state.isFocused;
      var isDisabled = Children.toArray(children).reduce(function (result, cur) {
        return result || safeSelect(cur, 'props.disabled');
      }, false);

      var _Label$getClassName = Label.getClassName({
        className: className,
        isDisabled: isDisabled,
        isFocused: isFocused
      }),
          root = _Label$getClassName.root;

      var clonedChildren = Children.toArray(children).map(function (el) {
        return typeof el === 'string' ? el : /*#__PURE__*/cloneElement(el, {
          onFocus: _this2.onFocus,
          onBlur: _this2.onBlur
        });
      });
      return /*#__PURE__*/React.createElement("label", {
        "data-qa": qa,
        className: root
      }, clonedChildren);
    }
  }]);

  return Label;
}(PureComponent);

var cx = classNamesFor(Label);

Label.useClassNames = function (x) {
  Label.classNames = x;
};

Label.getClassName = function (_ref) {
  var className = _ref.className,
      isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused;
  return {
    root: cx('psw-label', 'psw-l-inline', 'psw-l-line-left', {
      'psw-is-disabled': isDisabled
    }, {
      'psw-is-focused': isFocused
    }, className)
  };
};

Label.defaultProps = {
  qa: '',
  children: null,
  className: ''
};
Label.propTypes = {
  qa: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};
export default Label;